// extracted by mini-css-extract-plugin
export var fileUpload = "_dn-1";
export var modalButton = "_dn-0";